import BaseProxy from './Base';

class InfoProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('info', parameters, 'api/v1');
  }
  
  getInfo() {
    return this.load();
  }
}

export default InfoProxy;
